export const PERCENT_DECIMALS = 1;

export type MonitoringValueDisplayMode = 'volume' | 'rate' | 'proportion';

export const formatMonitoringPercent = (value: number): string =>
  `${value.toFixed(PERCENT_DECIMALS)}%`;

export const formatSignedMonitoringValue = (
  value: number,
  unit: string
): string => {
  const roundedValue = Number(value.toFixed(PERCENT_DECIMALS));
  const sign = roundedValue > 0 ? '+' : '';

  return `${sign}${roundedValue.toFixed(PERCENT_DECIMALS)}${unit}`;
};

export const formatMetricValue = (
  value: number,
  displayMode: MonitoringValueDisplayMode
): string =>
  displayMode === 'volume'
    ? value.toLocaleString()
    : formatMonitoringPercent(value);
